import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: require('@/views/login').default
    },
    {
      path: '/index',
      name: 'index',
      component: require('@/views/index').default,
      meta: { auth: true }
    },
    {
      path: '/coursePlayer',
      name: 'coursePlayer',
      component: require('@/views/course-player').default,
      meta: { auth: true }
    },
    {
      path: '/playbackRecord',
      name: 'playbackRecord',
      component: require('@/views/playback-record').default,
      meta: { auth: true }
    },
    {
      path: '/message',
      name: 'message',
      component: require('@/views/message').default,
      meta: { auth: true }
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: require('@/views/news-list').default,
      meta: { auth: true }
    },
    {
      path: '/newDetail',
      name: 'newDetail',
      component: require('@/views/new-detail').default,
      meta: { auth: true }
    },
    {
      path: '/searchResult',
      name: 'searchResult',
      component: require('@/views/search-result').default,
      meta: { auth: true }
    }
  ]
})
